import { generateNet, generateFormDataNet } from './generator'
import { singlepathInterceptor, multipathInterceptor, blobDownloadInterceptors } from './interceptors'

export const platNet = generateNet('plat')(singlepathInterceptor)
export const eimNet = generateFormDataNet('eim')(singlepathInterceptor)
export const runnerNet = generateNet('runner')(singlepathInterceptor)
export const platbaseNet = generateNet('platbase')(singlepathInterceptor)
export const platFomDataNet = generateFormDataNet('plat')(singlepathInterceptor)
export const platMultiNet = generateNet('plat')(multipathInterceptor)
export const runnerMultiNet = generateNet('runner')(multipathInterceptor)
export const platFomDataMultiNet = generateNet('plat')(multipathInterceptor)
export const platBlobNet = (params) => generateNet('plat', {
    timeout: 30000,
    responseType: 'blob',
})((instance) => blobDownloadInterceptors(instance, params))
